module.exports = __webpack_public_path__ + "img/ico_error_wifi.a2063b29.svg";